/** ***********************************************************************
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ************************************************************************* */

import { observer } from 'mobx-react';
import React from 'react';
import Button from '@react/react-spectrum/Button';
import Alert from '@react/react-spectrum/Icon/Alert';
import uuid from 'uuid';
import { ANALYTICS } from '../../utils/enums';
import './layout.scss';
import { ACTION_ID } from '../../utils/modelMapper/appModelMapper/appModelConstants';


@observer
class ProductPrimaryCTA extends React.Component {
    renderGuid = uuid.v4();

    componentDidMount() {
        const {
            appsSkeletonModel,
            appConfig,
            name,
            allAppsModel,
            urlData,
            analytics,
        } = this.props;
        const { bannerAnalyticsCallback } = analytics;
        const productSapcode = urlData.sapcode;
        const appModel = allAppsModel.getLatestVersionProdforSapcode(productSapcode);
        const ctaAction = allAppsModel.getProductCTAAction(productSapcode);

        bannerAnalyticsCallback('productCtaRendered', {
            id: name,
            CTAText: (ctaAction && ctaAction.actionId === ACTION_ID.NOT_COMPATIBLE) ? 'Not Compatible' : '',
            ingestId: urlData && urlData.ingestId,
            name: appModel && appModel.appFamilyName,
            sapcode: productSapcode,
            version: appModel && appModel.codexVersion,
            renderGuid: this.renderGuid,
        }, appConfig, appsSkeletonModel);
    }


    render() {
        const {
            allAppsModel,
            urlData,
            textColor,
            analytics,
            appsSkeletonModel,
            appConfig,
            name,
        } = this.props;
        const { bannerAnalyticsCallback } = analytics;

        const style = { color: textColor };
        const productSapcode = urlData.sapcode;
        const ctaAction = allAppsModel.getProductCTAAction(productSapcode);
        const appModel = allAppsModel.getLatestVersionProdforSapcode(productSapcode);

        if (ctaAction) {
            const {
                iconType, localizedText, ariaLabel, actionType = {},
            } = ctaAction;
            const errorIcon = (iconType ? <Alert variant={iconType} size="S" /> : null);
            const isQuiet = (actionType.quiet === true);
            if (!actionType.isDisabled) {
                style.borderColor = textColor;
            }

            return (

                <div render-guid={this.renderGuid}>
                    <Button
                        className="product-primary-cta"
                        label={localizedText}
                        aria-label={ariaLabel}
                        icon={errorIcon}
                        quiet={isQuiet}
                        style={{ ...style }}
                        disabled={actionType.isDisabled}
                        onClick={() => {
                            allAppsModel.handleProductCTAClick(productSapcode,
                                ANALYTICS.APPS, ANALYTICS.BANNER);
                            const guid = uuid.v4();
                            bannerAnalyticsCallback('productCtaClicked', {
                                id: name,
                                guid,
                                CTAText: (ctaAction && ctaAction.actionId === ACTION_ID.NOT_COMPATIBLE) ? 'Not Compatible' : '',
                                ingestId: urlData.ingestId,
                                name: appModel && appModel.appFamilyName,
                                sapcode: productSapcode,
                                version: appModel && appModel.codexVersion,
                            }, appConfig, appsSkeletonModel);
                        }}
                    />
                </div>
            );
        }
        return null;
    }
}


export default ProductPrimaryCTA;
